import { useEffect, useState } from "react";
import ManualPaymentInstructions from "../../components/payments/ManualPaymentInstructions";
import { fetchOrderStatus } from "../../services/publicApi";
import { formatCurrency, formatDate } from "../../utils/formatters";
import "./OrderConfirmationPage.css";

function getOrderNumberFromPath(pathname) {
  const match = pathname.match(/^\/order\/([^/]+)\/confirmation/);
  return match ? decodeURIComponent(match[1]) : "";
}

function OrderConfirmationPage() {
  const orderNumber = getOrderNumberFromPath(window.location.pathname);
  const params = new URLSearchParams(window.location.search);
  const customerEmail = params.get("email") || "";
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(Boolean(orderNumber));

  useEffect(() => {
    if (!orderNumber) {
      setLoading(false);
      return undefined;
    }

    let isMounted = true;

    async function loadOrder() {
      try {
        const payload = await fetchOrderStatus(orderNumber, customerEmail);

        if (isMounted) {
          setOrder(payload);
          setError("");
        }
      } catch (requestError) {
        if (isMounted) {
          setError(requestError.message || "We could not load this order.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadOrder();

    return () => {
      isMounted = false;
    };
  }, [customerEmail, orderNumber]);

  return (
    <main className="section confirmation-page">
      <div className="container confirmation-card">
        {loading ? <div className="empty-state">Loading order...</div> : null}
        {error ? <div className="cart-alert cart-alert--error">{error}</div> : null}
        {order ? (
          <>
            <p className="eyebrow">Order Received</p>
            <h1>Thank you, {order.customer_first_name}.</h1>
            <p className="muted-text">Order {order.order_number}</p>
            <div className="confirmation-grid">
              <div>
                <span>Status</span>
                <strong>{order.status}</strong>
              </div>
              <div>
                <span>Payment</span>
                <strong>{order.payment_status}</strong>
              </div>
              <div>
                <span>Location</span>
                <strong>{order.location?.name}</strong>
              </div>
              <div>
                <span>Requested</span>
                <strong>{formatDate(order.requested_date)} {order.requested_time}</strong>
              </div>
              <div>
                <span>Total</span>
                <strong>{formatCurrency(order.total)}</strong>
              </div>
            </div>
            <ManualPaymentInstructions order={order} />
            <a className="btn btn-primary" href="/menu">
              Back to Menu
            </a>
          </>
        ) : null}
      </div>
    </main>
  );
}

export default OrderConfirmationPage;
